import BlockRecommendedListing from './BlockRecommendedListing';
export default BlockRecommendedListing;
